import React from 'react'
import DataTable from 'react-data-table-component';
import Updatepartb from './updatepartb';
import { FaFilePdf, FaFileSignature, FaCheckCircle } from "react-icons/fa";
function ActionList({ journalid, codeid, stateflow, cansize }) {
    return (
        <div>
            <Updatepartb journalid={journalid} codeid={codeid} stateflow={stateflow} cansize={cansize} />
        </div>
    )
}

const columns = [
    {
        name: 'TDS code',
        sortable: true,
        selector: row => row.tdscode,
    },
    {
        name: 'V',
        grow: 0.1,
        selector: row => row.revision,
    },
    {
        name: 'Journal Type',
        selector: row => <div>
            <div>{row.journaltype}</div>
            <div style={{ color: "red" }}>Create by: ({row.createbyName})</div>
        </div>,
    },
    {
        name: 'customer/product',
        grow: 1,
        selector: row => <div>
            <div> : {row.customername}</div>
            <div> : {row.productname}</div>
            <div style={{color:'red'}}> : {row.productgrouptype}</div>

        </div>,
    },
    {
        name: 'confirm job',
        selector: row => <div>{row.statusConfirm == 1 && <label style={{ color: '#0e9a07' }}><FaCheckCircle />Approve</label>}</div>,
    },
    {
        name: 'createdate',
        selector: row => row.createdate,
    },
    {
        name: 'Action',
        grow: 0.5,
        cell: row => <ActionList journalid={row.journalId} codeid={row.tdscode} stateflow={row.stateflow} cansize={row.cansize} />,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};

const Tablefactory = ({ datatable }) => {

    // console.log(datatable);

    return (
        <DataTable
            columns={columns}
            data={datatable}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover
        />
    )
}

export default Tablefactory